@if (totalPages > 1) {
  <div class="flex gap-4 mt-2">
    <app-new-button
      class="h-8 w-20"
      data-test-id="previous-page-btn"
      [type]="'primary'"
      [size]="'responsive'"
      [disabled]="currentPageIndex === 0"
      (click)="selectPage.emit(currentPageIndex - 1)"
    >
      {{ 'core.paginationButtons.previousPageBtn' | translate }}
    </app-new-button>

    @for (pageIndex of getPages(); track pageIndex) {
      <app-new-button
        class="w-8 h-8"
        [attr.data-test-id]="pageIndex + 1 + '-page-btn'"
        [type]="'secondary'"
        [isActive]="currentPageIndex === pageIndex"
        (click)="selectPage.emit(pageIndex)"
      >
        {{ pageIndex + 1 }}
      </app-new-button>
    }

    <app-new-button
      data-test-id="next-page-btn"
      class="h-8 w-20"
      [type]="'primary'"
      [size]="'responsive'"
      [disabled]="currentPageIndex === totalPages - 1"
      (click)="selectPage.emit(currentPageIndex + 1)"
    >
      {{ 'core.paginationButtons.nextPageBtn' | translate }}
    </app-new-button>
  </div>
}
